// source: pbtypes/gen/flight_connect/device_node_health.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flight_connect_device_node_link_health_pb = require('../../../pbtypes/gen/flight_connect/device_node_link_health_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_device_node_link_health_pb);
var pbtypes_gen_flight_connect_device_node_peer_health_pb = require('../../../pbtypes/gen/flight_connect/device_node_peer_health_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_device_node_peer_health_pb);
goog.exportSymbol('proto.flight_connect.DeviceNodeHealth', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceNodeHealth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_connect.DeviceNodeHealth.repeatedFields_, null);
};
goog.inherits(proto.flight_connect.DeviceNodeHealth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceNodeHealth.displayName = 'proto.flight_connect.DeviceNodeHealth';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_connect.DeviceNodeHealth.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceNodeHealth.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceNodeHealth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceNodeHealth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceNodeHealth.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
serial: jspb.Message.getFieldWithDefault(msg, 2, ""),
peerHealthList: jspb.Message.toObjectList(msg.getPeerHealthList(),
    pbtypes_gen_flight_connect_device_node_peer_health_pb.DeviceNodePeerHealth.toObject, includeInstance),
linkHealthList: jspb.Message.toObjectList(msg.getLinkHealthList(),
    pbtypes_gen_flight_connect_device_node_link_health_pb.DeviceNodeLinkHealth.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceNodeHealth}
 */
proto.flight_connect.DeviceNodeHealth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceNodeHealth;
  return proto.flight_connect.DeviceNodeHealth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceNodeHealth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceNodeHealth}
 */
proto.flight_connect.DeviceNodeHealth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSerial(value);
      break;
    case 3:
      var value = new pbtypes_gen_flight_connect_device_node_peer_health_pb.DeviceNodePeerHealth;
      reader.readMessage(value,pbtypes_gen_flight_connect_device_node_peer_health_pb.DeviceNodePeerHealth.deserializeBinaryFromReader);
      msg.addPeerHealth(value);
      break;
    case 4:
      var value = new pbtypes_gen_flight_connect_device_node_link_health_pb.DeviceNodeLinkHealth;
      reader.readMessage(value,pbtypes_gen_flight_connect_device_node_link_health_pb.DeviceNodeLinkHealth.deserializeBinaryFromReader);
      msg.addLinkHealth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceNodeHealth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceNodeHealth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceNodeHealth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceNodeHealth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPeerHealthList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      pbtypes_gen_flight_connect_device_node_peer_health_pb.DeviceNodePeerHealth.serializeBinaryToWriter
    );
  }
  f = message.getLinkHealthList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      pbtypes_gen_flight_connect_device_node_link_health_pb.DeviceNodeLinkHealth.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 utime = 1;
 * @return {number}
 */
proto.flight_connect.DeviceNodeHealth.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodeHealth} returns this
 */
proto.flight_connect.DeviceNodeHealth.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string serial = 2;
 * @return {string}
 */
proto.flight_connect.DeviceNodeHealth.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceNodeHealth} returns this
 */
proto.flight_connect.DeviceNodeHealth.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DeviceNodePeerHealth peer_health = 3;
 * @return {!Array<!proto.flight_connect.DeviceNodePeerHealth>}
 */
proto.flight_connect.DeviceNodeHealth.prototype.getPeerHealthList = function() {
  return /** @type{!Array<!proto.flight_connect.DeviceNodePeerHealth>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_flight_connect_device_node_peer_health_pb.DeviceNodePeerHealth, 3));
};


/**
 * @param {!Array<!proto.flight_connect.DeviceNodePeerHealth>} value
 * @return {!proto.flight_connect.DeviceNodeHealth} returns this
*/
proto.flight_connect.DeviceNodeHealth.prototype.setPeerHealthList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.flight_connect.DeviceNodePeerHealth=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.DeviceNodePeerHealth}
 */
proto.flight_connect.DeviceNodeHealth.prototype.addPeerHealth = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.flight_connect.DeviceNodePeerHealth, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_connect.DeviceNodeHealth} returns this
 */
proto.flight_connect.DeviceNodeHealth.prototype.clearPeerHealthList = function() {
  return this.setPeerHealthList([]);
};


/**
 * repeated DeviceNodeLinkHealth link_health = 4;
 * @return {!Array<!proto.flight_connect.DeviceNodeLinkHealth>}
 */
proto.flight_connect.DeviceNodeHealth.prototype.getLinkHealthList = function() {
  return /** @type{!Array<!proto.flight_connect.DeviceNodeLinkHealth>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_flight_connect_device_node_link_health_pb.DeviceNodeLinkHealth, 4));
};


/**
 * @param {!Array<!proto.flight_connect.DeviceNodeLinkHealth>} value
 * @return {!proto.flight_connect.DeviceNodeHealth} returns this
*/
proto.flight_connect.DeviceNodeHealth.prototype.setLinkHealthList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.flight_connect.DeviceNodeLinkHealth=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.DeviceNodeLinkHealth}
 */
proto.flight_connect.DeviceNodeHealth.prototype.addLinkHealth = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.flight_connect.DeviceNodeLinkHealth, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_connect.DeviceNodeHealth} returns this
 */
proto.flight_connect.DeviceNodeHealth.prototype.clearLinkHealthList = function() {
  return this.setLinkHealthList([]);
};


goog.object.extend(exports, proto.flight_connect);
